:host {
  --dc-ui-link-animation-duration: 0.35s;
  --dc-ui-link-focus-color: #{$color-turquoise-03};
  --dc-ui-link-focus-color-inset: #{$color-white};

  --dc-ui-link-primary-active: #{$color-turquoise-06};
  --dc-ui-link-primary-color: #{$color-turquoise-04};
  --dc-ui-link-primary-focus: #{$color-turquoise-04};
  --dc-ui-link-primary-hover: #{$color-turquoise-05};
  --dc-ui-link-primary-disabled: #{$color-grey-03};

  --dc-ui-link-secondary-active: #{$color-grey-10};
  --dc-ui-link-secondary-color: #{$color-grey-06};
  --dc-ui-link-secondary-focus: #{$color-grey-06};
  --dc-ui-link-secondary-hover: #{$color-grey-08};
  --dc-ui-link-secondary-disabled: #{$color-grey-03};

  @media screen and (prefers-reduced-motion: reduce) {
    --dc-ui-link-animation-duration: 0s;
  }

  display: flex;
  width: auto;
}

:host(.inline) {
  display: inline-block;
}

:host([theme='dark']) {
  --dc-ui-link-primary-active: #{$color-turquoise-06};
  --dc-ui-link-primary-color: #{$color-turquoise-04};

  // primary link
  --dc-ui-link-primary-color: #{$color-turquoise-01};
  --dc-ui-link-primary-hover: #{$color-white};
  --dc-ui-link-primary-focus: #{$color-turquoise-01};
  --dc-ui-link-primary-active: #{$color-white};
  --dc-ui-link-primary-disabled: #{$color-grey-07};

  // secondary link
  --dc-ui-link-secondary-color: #{$color-dark-blue-01};
  --dc-ui-link-secondary-hover: #{$color-white};
  --dc-ui-link-secondary-focus: #{$color-dark-blue-01};
  --dc-ui-link-secondary-active: #{$color-white};
  --dc-ui-link-secondary-disabled: #{$color-grey-07};
}

.dc-ui-link {
  background-color: transparent;
  display: inline-flex;
  line-height: inherit;
  text-decoration: none;
  position: relative;
  vertical-align: bottom;

  &:focus-visible {
    outline: none;

    &:before {
      content: '';
      position: absolute;
      inset: -1px;
      border: 1px solid var(--dc-ui-link-focus-color);
      z-index: 1;
    }
  }

  &:hover {
    &:not(.disabled):not([disabled]) {
      transition: color var(--dc-ui-link-animation-duration);

      dc-ui-text {
        text-decoration: underline;
      }
    }
  }

  &--primary {
    color: var(--dc-ui-link-primary-color);

    &:active {
      &:not(.disabled):not([disabled]) {
        color: var(--dc-ui-link-primary-active);
      }
    }

    &:hover {
      &:not(.disabled):not([disabled]) {
        color: var(--dc-ui-link-primary-hover);
      }
    }

    &.disabled,
    &[disabled] {
      cursor: not-allowed;
      color: var(--dc-ui-link-primary-disabled);
    }
  }

  &--secondary {
    color: var(--dc-ui-link-secondary-color);

    &:active {
      &:not(.disabled):not([disabled]) {
        color: var(--dc-ui-link-secondary-active);
      }
    }

    &:hover {
      &:not(.disabled):not([disabled]) {
        color: var(--dc-ui-link-secondary-hover);
      }
    }

    &.disabled,
    &[disabled] {
      cursor: not-allowed;
      color: var(--dc-ui-link-secondary-disabled);
    }
  }

  &--small {
    dc-ui-icon {
      margin-right: 0.625rem;
    }
  }

  &--normal {
    dc-ui-icon {
      margin-right: 8px;
    }
  }

  &--underlined {
    dc-ui-text {
      text-decoration: underline;
    }
  }
}
